import React from 'react';
import "./index.css";
import "./mobile.css";

function Blog({ content, indexNumber, left, top, imageSource, heading,closeFunction,moveFunction,upFunction,downFunction,zIndex }) {
    return (
        <div className="dialog-box blog" id={indexNumber} 
        style={{ left: left, 
            top: top, 
            zIndex:zIndex
        }}
        onMouseMove={moveFunction}
        onMouseUp={upFunction}
        data-boxindex={indexNumber}
        >
            <div className="dialog-box-heading big-text draggable-box"
             onMouseDown={downFunction}
             data-boxindex={indexNumber}
            >
                <div className="dialog-box-info draggable-box" data-boxindex={indexNumber}>
                    <div className='draggable-box' data-boxindex={indexNumber}>{heading}</div>
                </div>
                <img className="close-button" src="./images/UI/close.png" alt="close button" onClick={()=>{closeFunction(indexNumber)}} />
            </div>
            <div className="dialog-box-body small-text" dangerouslySetInnerHTML={{ __html: content }}  > 
            </div>
        </div>
    );
}

export default Blog;
